import * as S from './styles'

import { format, parse } from 'date-fns'
import { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import * as Yup from 'yup'

import { yupResolver } from '@hookform/resolvers/yup'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { Grid } from '@mui/material'

import backgroundLogo from '../../assets/images/background_logo.png'

import { ButtonLarge } from 'src/components/ButtonLarge'
import { DatePicker } from 'src/components/DatePicker'
import { ErrorText } from 'src/components/ErrorText'
import { TextFieldComponent } from 'src/components/TextFieldComponent'
import DataContext from 'src/contexts/DataContext'
import {
  useGetCandidateLoginToken,
  useGetPersonInformationLazy,
} from 'src/services/backend'

const CandidateLogin = () => {
  const navigate = useNavigate()
  const currentDate = new Date()
  const [errorMsg, setErrorMsg] = useState('')
  const { registration, setRegistration } = useContext(DataContext)
  const [getLoginToken, loginTokenResult] = useGetCandidateLoginToken()
  const [getCandidate, candidateResult] = useGetPersonInformationLazy()

  const validationScheema = Yup.object().shape({
    code: Yup.string().required('Código de inscrição é obrigatório'),
    date: Yup.date()
      .nullable()
      .required('Data de nascimento é obrigatória')
      .max(currentDate, 'Data de nascimento não pode ser superior á data atual')
      .typeError('Formato de data inválido'),
  })

  const defaultValues = {
    code: '',
    date: undefined,
  }

  const {
    control,
    formState: { errors, isValid, isDirty },
    handleSubmit,
  } = useForm({
    defaultValues,
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationScheema),
  })

  const onSubmit = (data: any) => {
    if (isFormValid()) {
      const newData = {
        candidateCode: data.code,
        date: format(data.date, 'yyyy-MM-dd'),
      }
      if (isDirty) {
        registration.setCode(setRegistration, newData.candidateCode)
        registration.setDate(setRegistration, newData.date)
        getLoginToken(newData)
      }
    }
  }

  const isFormValid = () => isValid || !Object.keys(errors)?.length

  useEffect(() => {
    if (loginTokenResult.status === 200) {
      navigate('/candidato/seguranca')
      setErrorMsg('')
    }
  }, [loginTokenResult.status])

  useEffect(() => {
    if (candidateResult.data) {
      registration.setCandidate(setRegistration, candidateResult.data.response)
      setErrorMsg('')
    }
  }, [candidateResult.data])

  useEffect(() => {
    if (loginTokenResult.error) {
      setErrorMsg('Os dados inseridos estão incorretos')
    }
  }, [loginTokenResult.error])

  return (
    <S.ContainerFlex onSubmit={handleSubmit(onSubmit)}>
      <S.ContainerImage>
        <img src={backgroundLogo} alt="Imagem do logotipo da Germinare" />
      </S.ContainerImage>
      <S.Content>
        <S.Content>
          <S.Title>Bem-vindo(a) à Área do Candidato!</S.Title>
          <S.Typography>
            Para acessar, preencha os campos abaixo com os dados do(a)
            <span> candidato(a)</span>
          </S.Typography>

          <Grid container item xs={12} spacing={2}>
            <Grid item lg={12} md={12} xs={12}>
              <Controller
                name="code"
                control={control}
                render={({ field, fieldState }) => (
                  <TextFieldComponent
                    {...field}
                    label={'Informe o código de inscrição do(a) candidato(a)'}
                    fullWidth
                    error={!!fieldState.error}
                  />
                )}
              />
              <ErrorText message={errors.code && errors.code.message} />
            </Grid>
            <Grid item lg={12} md={12} xs={12}>
              <Controller
                name="date"
                control={control}
                render={({ field, fieldState }) => (
                  <DatePicker
                    {...field}
                    sx={{
                      width: '100%',
                    }}
                    label="Data de nascimento"
                    inputFieldProps={{ error: !!fieldState.error }}
                    value={
                      field.value
                        ? parse(field.value, 'yyyy-MM-dd', new Date())
                        : undefined
                    }
                  />
                )}
              />
              <ErrorText message={errors.date && errors.date.message} />
              {errorMsg && <ErrorText message={errorMsg} />}
            </Grid>
          </Grid>

          <ButtonLarge
            type="submit"
            variant={'contained'}
            endIcon={<ArrowForwardIosIcon />}
          >
            acessar área do candidato
          </ButtonLarge>
        </S.Content>
      </S.Content>
    </S.ContainerFlex>
  )
}

export { CandidateLogin }
